/**
 * Created by StoneWang on 2020/11/27.
 */
import React from 'react';
import {
    hashHistory,
    withRouter,
} from 'react-router';
import {
    Row,
    Col,
    Form,
    Table,
    Input,
    Modal,
    Button,
    message,
} from 'antd';
import {
    DmsTab,
} from 'Components';
import {
    config,
    openNotice,
    showSpin,
    hideSpin,
    returnFloat,
} from 'Utils';
import {
    addQuotation,
    updateQuotation,
    quotationDetail,
} from '../../service/quotation';
import PDFModal from './PDFModal.js';

const FormItem = Form.Item;
const confirm = Modal.confirm;

class MerchandiseAdd extends React.Component {
    constructor(props) {
        super(props);
        this.id = props.params.id === '0' ? 0 : props.params.id;
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            visible: false,
            submiting: false,
            groupOptions: [], // 商品分组
            seriesOptions: [], // 商品系列
            fittingTree: [],
            productCategoryTree: [],
            detail: {
                amount: 0, // 商品总额：所选商品牌价和
                downAmount: 0, // 优惠金额：根据每个商品的下浮价的和
                realityAmount: 0, // 实际总金额：商品总额-优惠金额-折扣金额
                discountAmount: 0, // 整单折扣：类似抹零操作，减去对应的金额
            },
            defaultActiveKey: 1,
            loadingSpec: false,
            visibleSpec: false,
            productTotal: 0,
            productRelationList: [],
            productParams: {
                name: '',
                channelCode: this.channelData.split('|')[1] || '',
                commodityId: this.id, //商品id
                s: 10,
                p: 1,
            },
            deleteRowKeys: [], // 选择的产品 id
            button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end') || '{}'),
        };
        this.goSelectProduct = this.goSelectProduct.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.onSearchHandle = this.onSearchHandle.bind(this);
    }

    componentDidMount() {
        let self = this;
        if (this.id) {
            /*获取详情数据*/
            quotationDetail(this.id).then(function (result) {
                if (result && result.code == 200) {
                    let detail = result.data || {};
                    let realityAmountSum = 0;
                    let countSum = 0;
                    let downAmountSum = 0;
                    let list = (detail.offerProductVoList || []).map(x => ({
                        'id': x.id, // 报价单关联产品记录ID
                        'offerId': x.offerId, // 报价单ID
                        'productCode': x.productCode, //产品物料编码
                        'productDesc': x.productDesc, //产品物料编码
                        'price': x.price, //牌价
                        'downRate': parseFloat(x.downRate), //下浮率（%）
                        'downPrice': x.downPrice, //下浮价--牌价*(1-downRate)
                        'count': x.count, //数量
                        'packageQuantity': x.packageQuantity, //装箱数
                        'unit': x.unit, //单位
                        'amount': x.amount, //产品金额
                        'downAmount': x.downAmount, //优惠金额
                        // 'realityAmount': x.realityAmount, //实际金额
                        'realityAmount': x.downPrice * x.count, //实际金额
                        'remark': x.remark, // 备注（非必填）
                    }));
                    list.forEach(m => {
                        realityAmountSum += m.realityAmount;
                        countSum += m.count;
                        downAmountSum += m.downAmount;
                    })
                    list.push({
                        productCode: '',
                        downPrice: '合计',
                        count: countSum,
                        downAmount: downAmountSum,
                        realityAmount: realityAmountSum
                    })
                    self.setState({
                        detail,
                        productRelationList: list,
                        productValidateStatus: !!list.length ? '' : 'error',
                    });
                } else {
                    openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
                }
            });
        }
    }

    goView(url) {
        hashHistory.push(url);
    }

    cancelHandle() {
        hashHistory.goBack();
    }


    goSelectProduct() {
        this.setState({
            visible: true,
        });
    }

    //详情导出
    exportText() {
        var id = this.id;
        window.location.href = `${config.server}/api/v1/dms/offer/export/${id}`;
    }

    addProduct = (list) => {
        const {detail} = this.state;
        let amount = 0; // 商品总额：所选商品牌价和
        let downAmount = 0; // 优惠金额：根据每个商品的下浮价的和
        let realityAmount = 0; // 实际总金额：商品总额-优惠金额-折扣金额
        //let discountAmount = 0; // 整单折扣：类似抹零操作，减去对应的金额
        list.forEach(x => {
            amount += x.count * x.price;
            downAmount += (x.price - x.downPrice || 0) * x.count;
        });
        realityAmount = amount - downAmount - detail.discountAmount;
        this.setState({
            detail: {
                ...detail,
                amount,
                downAmount,
                realityAmount,
            },
            productRelationList: list,
            productValidateStatus: !!list.length ? '' : 'error',
        });
    };

    deleteProduct() {
        const self = this;
        const {deleteRowKeys, productRelationList} = this.state;
        if (!deleteRowKeys.length) {
            message.warn('请选择要删除的产品');
            return;
        }
        confirm({
            title: '确定要删除这些产品?',
            onOk() {
                self.setState({
                    deleteRowKeys: [],
                    productRelationList: (productRelationList || []).filter(x => !deleteRowKeys.includes(x.productCode)),
                });
            },
            onCancel() {
            },
        });
    }

    deleteHandle(index) {
        const {deleteRowKeys, productRelationList} = this.state;
        let tmp = productRelationList.splice(index, 1)[0];
        this.setState({
            productRelationList,
            deleteRowKeys: deleteRowKeys.filter(x => x !== tmp.productCode),
        });
    }

    onSearchHandle(val) {
        this.setState({
            productParams: {
                ...this.state.productParams,
                name: val,
                p: 1,
            },
        }, () => {
            this.getProductListForCommodity();
        });
    }

    pageChange(page, pageSize) {
        this.setState({productParams: {...this.state.productParams, s: pageSize, p: page}}, () => {
            this.getProductListForCommodity();
        });
    }

    ///////
    productListChange(key, value, index) {
        const {productRelationList, detail} = this.state;
        let tmp = {...productRelationList[index]};
        if (key === 'downPrice' || key === 'downRate') {
            tmp[key] = value;
            if (key === 'downPrice') {
                tmp.downRate = (((tmp.price - value) / (tmp.price)) * 100).toFixed(2);
            }
            if (key === 'downRate') {
                tmp.downPrice = (tmp.price * (1 - value * 0.01)).toFixed(2);
            }
        } else {
            tmp[key] = value;
        }
        productRelationList.splice(index, 1, tmp);
        let amount = 0; // 商品总额：所选商品牌价和
        let downAmount = 0; // 优惠金额：根据每个商品的下浮价的和
        let realityAmount = 0; // 实际总金额：商品总额-优惠金额-折扣金额
        //let discountAmount = 0; // 整单折扣：类似抹零操作，减去对应的金额
        productRelationList.forEach(x => {
            amount += x.count * x.price;
            downAmount += (x.price - x.downPrice || 0) * x.count;
        });
        realityAmount = amount - downAmount - (detail.discountAmount || 0);
        this.setState({
            detail: {
                ...detail,
                amount,
                downAmount,
                realityAmount,
            },
            productRelationList,
        });
    }

    discountAmountChange(val) {
        const {detail} = this.state;
        let realityAmount = detail.amount - detail.downAmount - val;
        this.setState({
            detail: {
                ...detail,
                realityAmount,
                discountAmount: val,
            },
        });
    }

    openPrintWindow = (e) => {
        e.preventDefault();
        this.pdfModal.openHandle();
    };

    render() {
        const {
            submiting, detail, productRelationList, visible, deleteRowKeys,
        } = this.state;
        // const productModalProps = {
        //   visible: visible,
        //   selectedProducts: productRelationList,
        //   addProduct: (arr) => this.addProduct(arr),
        //   // onOk: this.onOkHandle,
        //   onCancel: () => this.setState({ visible: false }),
        // };
        const lastIndex = productRelationList.length - 1;
        const productTableProps = {
            rowKey: 'productCode',
            pagination: false,
            /*pagination: {
             total: productTotal,
             showTotal: total => `总共 ${total} 条`,
             current: productParams.p,
             pageSize: productParams.s,
             onShowSizeChange: (current, pageSize) => this.pageChange(1, pageSize),
             onChange: (current, pageSize) => this.pageChange(current, pageSize),
             },*/
            dataSource: productRelationList,
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'productCode',
                },
                {
                    title: '物料描述',
                    dataIndex: 'productDesc',
                    width: 200,
                },
                {
                    title: '装箱数',
                    dataIndex: 'packageQuantity',
                },
                {
                    title: '数量',
                    dataIndex: 'count',
                },
                {
                    title: '面价',
                    dataIndex: 'price',
                    render: text => <span style={{color: '#d61518'}}>{returnFloat(text)}</span>,
                },
                {
                    title: '折扣单价',
                    dataIndex: 'downPrice',
                    render: (text, record, index) => {
                        if (lastIndex > -1 && index === lastIndex) {
                            return text
                        }
                        return <span style={{color: '#d61518'}}>{returnFloat(text)}</span>
                    },
                },
                {
                    title: '金额',
                    dataIndex: 'realityAmount',
                    render: text => <span style={{color: '#d61518'}}>{returnFloat(text)}</span>,
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    // render: (text, record, index) => (
                    //   <Input
                    //     value={text}
                    //     onChange={(e) => this.productListChange('remark', e.target.value, index)}
                    //     style={{ width: '100%' }} />),
                },
                // {
                //   title: '操作',
                //   dataIndex: 'opt',
                //   render: (val, record, index) => {
                //     return <a onClick={() => this.deleteHandle(index)}>删除</a>;
                //   },
                // },
            ],
            // rowSelection: {
            //   selectedRowKeys: deleteRowKeys,
            //   onChange: (selectedRowKeys, selectedRows) => {
            //     this.setState({ deleteRowKeys: selectedRowKeys });
            //   },
            // },
        };
        return <div className="dms-body">
            <DmsTab options={[`报价单详情`]} defaultKey={0}>
                <Button onClick={this.cancelHandle.bind(this)}><a
                    href={`${config.server}/api/v1/dms/offer/downWord?id=${this.id}`} target="_blank">下载</a></Button>
                <Button onClick={(e) => this.openPrintWindow(e)}>打印</Button>
                <Button icon="export" onClick={this.exportText.bind(this)}> 导出 </Button>
                <Button type='primary' onClick={() => this.goView(`/quotation/add/${this.id}`)}>编辑</Button>
                <Button onClick={this.cancelHandle.bind(this)}>返回</Button>
                {/*<Button type='primary' loading={submiting} onClick={this.submitHandle.bind(this)}>保存</Button>*/}
            </DmsTab>
            <div className="tab_individual add_product">
                <Form layout="inline">
                    <div style={{padding: '12px', background: '#fff'}}>
                        <Row gutter={16}>
                            <Col className="gutter-row" span={12}>
                                <FormItem label="报价单号：">
                                    {detail.offerCode || ''}
                                </FormItem>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <FormItem label="客户名称">
                                    {detail.customerName || ''}
                                </FormItem>
                            </Col>
                        </Row>
                        <FormItem label="备注">
                            <p>{detail.remark || ''}</p>
                        </FormItem>
                        <DmsTab options={['商品']} defaultKey={0}>
                            {/*<Button onClick={() => this.goSelectProduct()}>添加</Button>*/}
                            {/*&emsp;*/}
                            {/*<Button onClick={() => this.deleteProduct()}>删除</Button>*/}
                        </DmsTab>
                        <div className="dms-table-box">
                            <Table {...productTableProps} />
                        </div>
                        <div className="dms-split-bar"></div>
                        <Row type="flex" justify="start" style={{flexDirection: 'column', alignItems: 'flex-end'}}>
                            <div style={{width: 200, paddingRight: 10}}>
                                <Row>
                                    <Col span={11} style={{textAlign: 'right'}}>商品总金额：</Col>
                                    <Col span={13}><p style={{textAlign: 'right'}}><span
                                        className="dms-red">{returnFloat(detail.amount)}</span></p></Col>
                                </Row>
                                <Row>
                                    <Col span={11} style={{textAlign: 'right'}}>优惠金额：</Col>
                                    <Col span={13}><p style={{textAlign: 'right'}}><span
                                        className="dms-red">{returnFloat(detail.downAmount)}</span></p></Col>
                                </Row>
                                <Row>
                                    <Col span={11} style={{textAlign: 'right'}}>整单折扣：</Col>
                                    <Col span={13}><p style={{textAlign: 'right'}}><span
                                        className="dms-red">{returnFloat(detail.discountAmount)}</span></p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11} style={{textAlign: 'right'}}>实际总金额：</Col>
                                    <Col span={13}><p style={{textAlign: 'right'}}><span
                                        className="dms-red">{returnFloat(detail.realityAmount)}</span></p></Col>
                                </Row>
                            </div>
                        </Row>
                    </div>
                </Form>
            </div>
            <PDFModal ref={node => this.pdfModal = node} detail={detail} productTableProps={productTableProps}/>
        </div>
            ;
    }
}

export default withRouter(Form.create()(MerchandiseAdd));



// WEBPACK FOOTER //
// ./src/routes/quotation/detail.js